const ACCESS_TOKEN_KEY = "nommia.accessToken";

export const getStoredAccessToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return (
      window.localStorage.getItem(ACCESS_TOKEN_KEY) ??
      window.sessionStorage.getItem(ACCESS_TOKEN_KEY)
    );
  } catch {
    return null;
  }
};

export const persistAccessToken = (token: string, remember: boolean) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const storage =
      remember && "localStorage" in window
        ? window.localStorage
        : window.sessionStorage;

    storage.setItem(ACCESS_TOKEN_KEY, token);
  } catch (error) {
    console.warn("[auth] Unable to persist access token", error);
  }
};

export const clearStoredAccessToken = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
    window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch (error) {
    console.warn("[auth] Unable to clear stored access token", error);
  }
};

export const hasStoredAccessToken = () =>
  Boolean(getStoredAccessToken()?.trim());

export { ACCESS_TOKEN_KEY };
